import { getCurrentLocale } from "@/utils/locale";
import { toLocalDate } from "@/utils/datetime";

// Per the Figma design, the in-app greeting's date never carries a year (the card title
// below it does) — regardless of which year the meeting falls in, unlike simpleDate's
// hideCurrentYear option, which only hides the year for the current calendar year.
export const getMeetingPrepGreetingDate = (
  meetingDate: string | undefined
): string => {
  if (!meetingDate) return "";
  return new Intl.DateTimeFormat(getCurrentLocale(), {
    month: "long",
    day: "numeric"
  }).format(toLocalDate(meetingDate));
};

export type MeetingPrepGreetingKey =
  | "meetingPrep.greeting"
  | "meetingPrep.greetingNoName"
  | "meetingPrep.greetingNoDate"
  | "meetingPrep.greetingNoNameNoDate";

export const getMeetingPrepGreetingKey = (
  hasName: boolean,
  hasDate: boolean
): MeetingPrepGreetingKey => {
  if (hasName && hasDate) return "meetingPrep.greeting";
  if (hasName && !hasDate) return "meetingPrep.greetingNoDate";
  if (!hasName && hasDate) return "meetingPrep.greetingNoName";
  return "meetingPrep.greetingNoNameNoDate";
};
